import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';

import { Errors, ResponseMessageModel } from '../../domains/common.domain';
import { UserService } from '../user.service';

@Injectable()
export class ErrorService {
  errorMessage: string;
  responseMessage: ResponseMessageModel;
  successMessage: string;
  messageKey: string = 'app-notifier';
  messageLife: number = 3000;

  constructor(private router: Router, private messageService: MessageService, private userService: UserService) {
    this.errorMessage = '';
    this.successMessage = '';
    this.responseMessage = null;
  }

  private static verifyResponseStatus(response: any): string {
    return response.body && response.body.status === '02' ? 'error' : 'success';
  }

  throwErrorIfFailure(response: any, displayToast: boolean = false, callback: () => void = null): void {
    this.errorMessage = '';
    this.successMessage = '';
    this.responseMessage = null;

    const allErrors = [];
    Object.keys(Errors).forEach(key => {
      allErrors.push(Errors[key]);
    });

    if (response instanceof HttpErrorResponse) {
      if (callback && typeof callback === 'function') {
        callback();
      }

      if (typeof response.error === 'string' && response.error.indexOf('<html>') === -1) {
        this.errorMessage = response.error;
      } else if (
        typeof response.error === 'object' &&
        response.error.result &&
        allErrors.indexOf(response.error.result.toLowerCase()) > -1
      ) {
        this.errorMessage = response.error.message || 'Unexpected exception thrown by the application.';
        if (response.status === 401) {
          this.router.navigate(['']);
          setTimeout(() => {
            this.userService.clearUserData();
          });
        }
      } else if (response.message) {
        this.errorMessage = response.message;
      }

      this.responseMessage = {
        severity: 'error',
        detail: this.errorMessage,
        data: {
          msgType: 'string',
        },
      };
      // throw new Error(this.errorMessage);
    } else {
      if (
        response &&
        ((response.body && response.body.result && allErrors.indexOf(response.body.result.toLowerCase()) > -1) ||
          (response.result && allErrors.indexOf(response.result.toLowerCase()) > -1))
      ) {
        if (callback && typeof callback === 'function') {
          callback();
        }
        this.errorMessage =
          (response.body && response.body.message) || response.message || 'Unexpected exception thrown by the application.';

        this.responseMessage = {
          severity: 'error',
          detail: this.errorMessage,
          data: {
            msgType: 'string',
          },
        };
        // throw new Error(this.errorMessage);
        // this.router.navigate(['/dashboard']);
      } else if (response && (response.body || response.result === 'success' || response.result === 'updated')) {
        const responseType = ErrorService.verifyResponseStatus(response);

        if (responseType === 'success') {
          this.successMessage = (response.body && response.body.message) || 'Operation successful.';

          this.responseMessage = {
            severity: 'success',
            detail: this.successMessage,
            data: {
              msgType: 'string',
            },
          };
        } else {
          this.errorMessage = 'app.user-form.registration-user-exists';
          displayToast = false;

          this.responseMessage = {
            severity: 'error',
            detail: this.errorMessage,
            data: {
              msgType: 'locale',
            },
          };
        }
      }
    }

    if (displayToast && this.responseMessage) {
      this.createMessageToast();
    }
  }

  createMultipleMessages(messages: string[], severity: string): void {
    this.messageService.addAll(
      messages.map(message => ({ key: this.messageKey, severity: severity, detail: message, data: { msgType: 'string' } }))
    );
  }

  showError(message: string, life: number = 3000) {
    this.responseMessage = {
      severity: 'error',
      detail: message,
      data: {
        msgType: 'locale',
      },
    };
    this.messageLife = life;

    this.createMessageToast();
  }

  createMessageToast(): void {
    this.responseMessage.life = this.messageLife;
    this.responseMessage.key = this.messageKey;
    if (this.messageService) {
      this.messageService.clear(this.messageKey);
      this.messageService.add(this.responseMessage);
    }
  }
}
